import React from 'react'

export default function Section4() {
    return (
        <div className='min-h-screen grid content-center bg-[#0E081B]/30 py-10'>
            <div className='mx-auto w-[90%]'>
            <div className='flex justify-center'>
                <button className='px-10 py-2 rounded-full font-bold border border-white bg-black text-[#A880FF]'>WHY CHOOSE GOALDEX</button>
            </div>
            <div className='py-5 relative'>
                <p className='text-white font-medium text-2xl lg:text-4xl capitalize 2xl:text-5xl text-center'>Game-Changing Technology for Next-Gen Football</p>
                <p className='text-center text-white mt-4'>Your playbook for talent, performance, and fan power – all in one platform.</p>
            </div>
            </div>
            <div className='w-[90%] mx-auto flex flex-col gap-4 lg:gap-0 lg:flex-row justify-center mt-5'>
                <div className='lg:w-[50%] flex justify-center'>
                    <img className='ball-spin-reverse w-7/12' src='/assets/others/Ball3.svg'></img>
                </div>
                <div className='lg:w-[50%] flex flex-col gap-10'>
                    <div className='rounded-xl border border-white/60 backdrop-blur-[50px] py-3 px-2 flex justify-between bg-[#272727]/60' style={{ boxShadow: "0px 0px 15px #5C1FE2" }}>
                        <div className='w-[10%] flex justify-end items-start'>
                            <img className='' src='/assets/icon/sec-5-1.svg'></img>
                        </div>
                        <div className='w-[85%] '>
                            <div className='flex justify-start'>
                                <p className='font-bold text-xl text-[#AB84FF]'>Genetic AI-Powered Precision Coaching</p>
                            </div>
                            <div>
                                <p className='text-white text-sm mt-2'>Unlock next-level performance with personalized training plans based on DNA and real-time game data.</p>
                            </div>
                        </div>
                    </div>
                    <div className='rounded-xl border border-white/60 backdrop-blur-[50px] py-3 px-2 flex justify-between bg-[#272727]/60' style={{ boxShadow: "0px 0px 15px #5C1FE2" }}>
                        <div className='w-[10%] flex justify-end items-start'>
                            <img className='' src='/assets/icon/sec-5-2.svg'></img>
                        </div>
                        <div className='w-[85%] '>
                            <div className='flex justify-start'>
                                <p className='font-bold text-xl text-[#AB84FF]'>NFT Player Passports </p>
                            </div>
                            <div>
                                <p className='text-white text-sm mt-2'>Own your game with digital profiles that track stats, skills, and career milestones – secured by blockchain.</p>
                            </div>
                        </div>
                    </div>
                    <div className='rounded-xl border border-white/60 backdrop-blur-[50px] py-3 px-2 flex justify-between bg-[#272727]/60' style={{ boxShadow: "0px 0px 15px #5C1FE2" }}>
                        <div className='w-[10%] flex justify-end items-start'>
                            <img className='' src='/assets/icon/sec-5-3.svg'></img>
                        </div>
                        <div className='w-[85%] '>
                            <div className='flex justify-start'>
                                <p className='font-bold text-xl text-[#AB84FF]'>Smart Talent Acquisition </p>
                            </div>
                            <div>
                                <p className='text-white text-sm mt-2'>Leverage Genetic AI driven insights to scout, recruit, and manage players more efficiently, optimizing your club’s performance and budget.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
